<template>
    <div class="grid gap-5">
        <k-panel class="border">
            <p class="leading-7" style="white-space: pre-line;">{{ tranche.details.summary.market }}</p>
        </k-panel>
    </div>
</template>

<script>
export default {
    props: {
        tranche: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    mounted() {
    }
};
</script>

<style scoped>

</style>
